import { ButtonDropdown, DropdownMenu, DropdownToggle, Label } from "reactstrap";

import { components } from "react-select";

import Select from "react-select";

import DatePicker from 'react-datepicker';
import moment from 'moment';
import { CloseIcon, FilterIcon, filterBlackIcon } from "../../../assets/images";
import { CircularAvatar } from "../../commons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { CalenderIcon } from "../../Icon";

type DropDownOptionType = {
  value: number | null | undefined;
  label: string;
};
type FilterMultiSelectDataType = {
  user: { label: string; value: number | null };
};

type AppProps = {
  toggle: boolean;

  setToggle: (data: boolean) => void;
  finalUserList: DropDownOptionType[];

  filterValue: any;
  setFilterValue: any;
  handleApplyFilter: () => void;
  handleFilterClear: () => void;
  setFilterText: React.Dispatch<React.SetStateAction<string>>;
  limit: number;
  filterOffset: number;
  setFilterOffset: React.Dispatch<React.SetStateAction<number>>;
  filterText:string;
  multiSelectData:FilterMultiSelectDataType;
  type?:string;
};

const AllExternalEmailerFilter = ({
  toggle,
  setToggle,
  finalUserList,

  filterValue,
  setFilterValue,
  handleApplyFilter,
  handleFilterClear,
  setFilterText,
  limit,
  filterText,
  filterOffset,
  setFilterOffset,
  multiSelectData,
  type
  
}: AppProps) => {
    const filterCount: number = Object.values(multiSelectData).filter((e: any) =>
        e?.hasOwnProperty("value")
          ? e?.value?.toString()?.length > 0
          : e?.toString()?.length > 0
      ).length;
  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          {data?.label !== "Select" ? (
            <CircularAvatar
              name={data?.label}
              image={data?.image && data?.image}
            />
          ) : (
            <></>
          )}
          {data?.label}
        </div>
      </components.Option>
    );
  };

  const filterEndDateChange = (date: any) => {
    if (date !== "Invalid date") {
        setFilterValue((prev: any) => ({ ...prev, filterEndDate: date }))
    }
    else {
        setFilterValue((prev: any) => ({ ...prev, filterEndDate: "" }))
    }
}
const filterStartDateChange = (date: any) => {
    if (date !== "Invalid date") {
        setFilterValue((prev: any) => ({ ...prev, filterStartDate: date }))

    }
    else {
        setFilterValue((prev: any) => ({ ...prev, filterStartDate: "" }))

    }
}
  const clearFilter = () => {
    resetFilter();
    handleFilterClear();
  };

  const checkUserBottom = (e: any) => {
    setFilterOffset((prv: any) => prv + limit)
  };

  const empty = () => {
    // setFilterValue({ user: { label: "", value: null } });
  };

  const resetFilter = () => {
    setFilterValue({
      user: { label: "", value: null },
    });
  };

  return (
    <ButtonDropdown
      isOpen={toggle}
      toggle={() => {
        filterCount === 0 && toggle ? resetFilter() : empty();
        setToggle(!toggle);
      }}
    >
        <OverlayTrigger
        placement="bottom"
        delay={{ show: 250, hide: 250 }}
        overlay={
          <Tooltip id="button-view-download-invoice">
           Filter
          </Tooltip>
        }
      >
      <DropdownToggle
        caret
        color="#262a44"
        style={{
          border: "1px solid #bfcbe1",
          backgroundColor: "#ffffff",
          height: "38px",
        }}
      >
        <img src={filterCount !== 0 ? FilterIcon : filterBlackIcon} alt="" />
        <span className={filterCount !== 0 ? "filter-count" : ""}>
          <span>{filterCount !== 0 ? filterCount : ""}</span>
        </span>
      </DropdownToggle>
      </OverlayTrigger>
      <DropdownMenu right style={{ width: "400px", padding: "15px 25px 30px" }}>
        <div className="d-flex justify-content-between mt-0 mb-0">
          <h5 className="text-center ">Filter</h5>
          <div
            className="pointer"
            onClick={() => {
              setToggle(!toggle);
            }}
          >
            <img src={CloseIcon} alt="" />
          </div>
        </div>
        <hr className="mt-0 mb-2" />
        {type==="allUserApprovedEntryCount"?

        <div className="row mt-3">
                    <div className='d-flex'>
                        <div className="form-group col-md-6">
                            <div className='date-picker-wraper mr-0 position-relative'>
                                <Label className='mb-1 p-0 w-100' style={{ fontSize: "14px" }}>Start Date
                                <DatePicker
                                    dateFormat="dd-MM-yyyy"
                                    selected={filterValue?.filterStartDate ? new Date(moment(`${filterValue?.filterStartDate}T00:00:00`, 'YYYY-MM-DD').format('YYYY-MM-DD[T]HH:mm:ss')) : null}
                                    onChange={(e: any) => { filterStartDateChange(moment(e).format('YYYY-MM-DD')) }}
                                    fixedHeight
                                    showMonthDropdown
                                    showYearDropdown
                                    // onInputClick={()=>setText(choosefilterStartDate)}
                                    name='filterStartDate'
                                    placeholderText="Select"
                                    className='form-control'

                                />
                                <span className="calender-icon" style={{ top: "28px", right: '4px', cursor: 'pointer', position: "absolute" }}>
                                    <CalenderIcon />
                                </span>
                                </Label>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group">
                                <div className='date-picker-wraper mr-0'>
                                    <Label className='mb-1 p-0 w-100' style={{ fontSize: "14px" }}>End Date
                                    <DatePicker
                                        dateFormat="dd-MM-yyyy"
                                        selected={filterValue?.filterEndDate ? new Date(moment(`${filterValue?.filterEndDate}T00:00:00`, 'YYYY-MM-DD').format('YYYY-MM-DD[T]HH:mm:ss')) : null}
                                        onChange={(e: any) => { filterEndDateChange(moment(e).format('YYYY-MM-DD')) }}
                                        fixedHeight
                                        showMonthDropdown
                                        showYearDropdown
                                        name='filterEndDate'
                                        placeholderText='Select'
                                        className='form-control'
                                        // disabled={!choosefilterStartDate}
                                        minDate={filterValue?.filterStartDate ? new Date(moment(`${filterValue?.filterStartDate}T00:00:00`, 'YYYY-MM-DD').format('YYYY-MM-DD[T]HH:mm:ss')) : null}
                                    />
                                    <span className="calender-icon" style={{ top: "28px", right: '20px', cursor: 'pointer' }}>
                                        <CalenderIcon />
                                        </span>
                                        </Label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
         :""}
        <div className="row d-flex">
          <div className="col-md-12">
            <label className="mb-1" style={{ fontSize: "14px" }}>
              Select User
            </label>
            <Select
              options={[{ value: null, label: "Select" }, ...finalUserList]}
              value={filterValue?.user?.value ? filterValue?.user : "Select"}
              components={{ Option }}
              cacheOptions
              onChange={(e) =>
                setFilterValue((prev: any) => ({ ...prev, user: e }))
              }
              onMenuScrollToBottom={(e: any) => checkUserBottom(e)}
              onInputChange={(e: string) => {
                setFilterText(e);
              }}
              onMenuClose={() =>{ setFilterOffset(0)}}
              placeholder="Select"
            />
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-end mt-3">
          <button
            className="mr-2 btn btn-outline"
            onClick={() => {
              clearFilter();
              setToggle(!toggle);
            }}
          >
            Clear Filter
          </button>
          <button
            className="pl-4 pr-4 btn btn-primary"
            onClick={() => {
              handleApplyFilter();
              setToggle(!toggle);
            }}
          >
            Apply
          </button>
        </div>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default AllExternalEmailerFilter;
